module.exports = __webpack_public_path__ + "static/media/Avatars_Male-29.eea22572.png";